import { render, staticRenderFns } from "./AccountExtract.vue?vue&type=template&id=2be86c19"
import script from "./AccountExtract.vue?vue&type=script&lang=js"
export * from "./AccountExtract.vue?vue&type=script&lang=js"
import style0 from "./AccountExtract.vue?vue&type=style&index=0&id=2be86c19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports